import { isCSSStyleSheet, isNonNullableObject, isTemplateStringsArray, typeCheck, } from "@knyt/artisan";
import { CSSLength } from "./CSSLength.js";
import { CSSPercentage } from "./CSSPercentage.js";
import { cssTemplateTag } from "./cssTemplateTag.js";
import { isCSSSerializable } from "./isCSSSerializable.js";
import { StyleSheet } from "./StyleSheet.js";
import { toSize } from "./toSize.js";
export function css(input, ...args) {
    if (isTemplateStringsArray(input)) {
        const tagValues = args;
        return cssTemplateTag(input, ...tagValues);
    }
    if (isCSSStyleSheet(input)) {
        const [options] = args;
        return StyleSheet.fromCSSStyleSheet(input, options);
    }
    if (typeof input === "string" || isCSSSerializable(input)) {
        const [options] = args;
        return StyleSheet.fromCSS(input, options);
    }
    if (isNonNullableObject(input)) {
        const [options] = args;
        return StyleSheet.fromRules(input, options);
    }
    typeCheck(typeCheck.identify(input));
    throw new TypeError(`Invalid CSS input type: ${String(input)}.`);
}
(function (css) {
    /**
     * Convert the given value into either a `CSSLength` or `CSSPercentage`.
     *
     * @throws If the value is not recognized.
     * @remarks Given number value are assumed to be pixel units.
     *
     * @alpha This is an alpha export and WILL change (or be removed) in the future
     * without warning.
     */
    css.size = toSize;
    css.len = CSSLength.from;
    css.pct = CSSPercentage.from;
})(css || (css = {}));
